/*
 * td-pdp.js — o comportamento da página de produto da Todanua (Fase 2).
 *
 * 🔴 Zero biblioteca externa. Nada de jQuery, Swiper, GSAP ou Alpine. O
 * carrossel é `scroll-snap` do próprio navegador, o acordeão é <details> e o
 * modal é <dialog>. O que sobra para o JavaScript é só o que o HTML não sabe
 * fazer sozinho: observar quando um botão sai da tela, espelhar um estado e
 * abrir um <dialog>.
 *
 * Também não existe listener de `scroll` em lugar nenhum: tudo que depende de
 * posição usa IntersectionObserver. Listener de scroll roda a cada pixel e é o
 * jeito mais barato de estragar o INP, que é uma das metas do plano.
 *
 * Este arquivo só é baixado na página de produto — a tag <script> vive dentro
 * da seção main-product, não no layout.
 *
 * Decisões de negócio: NENHUMA aqui dentro. Tudo (se exige tamanho, quais
 * opções contam como tamanho, quais textos) chega pelos data-* e pelo JSON de
 * textos que o Liquid escreve. Assim o Marcus muda no editor, não no código.
 */
(function () {
  'use strict';

  var EVENT_VARIANT_CHANGE =
    (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) || 'variant-change';

  /* Os blocos que se atualizam quando ela troca de tamanho ou de cor.
     O Dawn já refaz preço, estoque e SKU; estes são os nossos.

     'TdStock' entrou na Fase 3 e é o mais importante da lista: a escassez do
     G6 é do TAMANHO escolhido, não do produto. Sem ele aqui, ela trocaria de
     P para GG e continuaria lendo "últimas 2 peças" do tamanho anterior — que
     é escassez falsa por descuido, e conta como escassez falsa do mesmo
     jeito. */
  var SYNC_IDS = ['TdInstallments', 'TdPix', 'TdSocialProof', 'TdStock'];

  function textsOf(root) {
    var node = root.querySelector('[data-td-strings]');
    if (!node) return {};
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      /* JSON quebrado não pode derrubar a página inteira de compra. */
      return {};
    }
  }

  /* ------------------------------------------------------------------ *
   * Modal (E3 opções de pagamento, F1 tabela de medidas)
   * Abrir é a única parte que o HTML não faz sozinho. Fechar é
   * <form method="dialog">, nativo, e continua funcionando com Esc.
   * O listener é UM só, delegado no documento: não cresce com a página.
   * ------------------------------------------------------------------ */
  function initModals() {
    if (document.documentElement.dataset.tdModals === 'on') return;
    document.documentElement.dataset.tdModals = 'on';

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-td-modal-open]');
      if (opener) {
        var dialog = document.getElementById(opener.getAttribute('data-td-modal-open'));
        if (dialog && typeof dialog.showModal === 'function') {
          event.preventDefault();
          dialog.showModal();
        }
        return;
      }

      /* Clique no fundo escuro fecha. O alvo do clique é o próprio <dialog>
         quando ela acerta o backdrop, porque o conteúdo é filho dele. */
      var openDialog = event.target;
      if (openDialog.tagName === 'DIALOG' && openDialog.classList.contains('td-modal')) {
        var box = openDialog.getBoundingClientRect();
        var fora =
          event.clientY < box.top ||
          event.clientY > box.bottom ||
          event.clientX < box.left ||
          event.clientX > box.right;
        if (fora) openDialog.close();
      }
    });
  }

  /* ------------------------------------------------------------------ *
   * G11 — copiar o cupom.
   * Um listener só, delegado no documento, como o dos modais: ele não
   * cresce com a página e sobrevive à seção ser recriada no editor.
   *
   * O texto de confirmação chega pelo data-*, já traduzido pelo Liquid.
   * Escrever "Copiado!" dentro deste arquivo seria a Boutique dizendo isso
   * em português para uma cliente americana.
   * ------------------------------------------------------------------ */
  function initCopy() {
    if (document.documentElement.dataset.tdCopy === 'on') return;
    document.documentElement.dataset.tdCopy = 'on';

    document.addEventListener('click', function (event) {
      var botao = event.target.closest('[data-td-copy]');
      if (!botao) return;

      var codigo = botao.getAttribute('data-td-copy') || '';
      var rotulo = botao.querySelector('.td-btn__label');
      var confirmacao = botao.getAttribute('data-td-copied') || '';

      function avisar() {
        if (!rotulo || !confirmacao || botao.dataset.tdBusy === 'true') return;
        botao.dataset.tdBusy = 'true';
        var antes = rotulo.textContent;
        rotulo.textContent = confirmacao;
        window.setTimeout(function () {
          rotulo.textContent = antes;
          delete botao.dataset.tdBusy;
        }, 2000);
      }

      /* A área de transferência moderna só existe em página segura e pode
         ser recusada pelo navegador. O caminho antigo (campo invisível +
         execCommand) continua funcionando em todos eles, então ele é o
         plano B — e não o contrário. */
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(codigo).then(avisar, function () {
          if (copiarNaMarra(codigo)) avisar();
        });
      } else if (copiarNaMarra(codigo)) {
        avisar();
      }
    });
  }

  function copiarNaMarra(texto) {
    var campo = document.createElement('textarea');
    /* Quem estava com o foco antes: selecionar o campo temporário tira o foco
       do botão, e não devolver deixa quem navega por teclado no meio do nada. */
    var focoAntes = document.activeElement;
    try {
      campo.value = texto;
      campo.setAttribute('readonly', 'readonly');
      /* Fora da tela, e não display:none: o navegador não copia de um
         elemento que não está sendo renderizado. */
      campo.style.position = 'fixed';
      campo.style.top = '-1000px';
      document.body.appendChild(campo);
      campo.select();
      return document.execCommand('copy');
    } catch (e) {
      return false;
    } finally {
      /* `finally` porque `execCommand` pode LANÇAR: sem isto, cada tentativa
         que falha deixa um campo de texto invisível pendurado no documento. */
      if (campo.parentNode) campo.parentNode.removeChild(campo);
      if (focoAntes && focoAntes.focus && focoAntes.isConnected) {
        focoAntes.focus({ preventScroll: true });
      }
    }
  }

  /* ------------------------------------------------------------------ *
   * G8 — a calculadora de frete por CEP (só a loja nacional, e desligada
   * por padrão).
   *
   * 🔴 Este arquivo NÃO calcula frete. Ele pergunta à própria Shopify, no
   * endpoint nativo do carrinho, e mostra o que vier. Não existe tabela,
   * não existe estimativa e não existe API de terceiro — foi prazo
   * inventado que derrubou a calculadora anterior da loja.
   *
   * O nome da opção ("PAC (5 a 8 dias úteis)") é o que a própria loja
   * escreveu nas configurações de envio. Por isso eu mostro o nome inteiro
   * em vez de tentar montar uma frase de prazo: o texto certo já existe, e
   * qualquer frase minha por cima dele seria chute.
   * ------------------------------------------------------------------ */
  function initCep(root, texts) {
    /* querySelectorAll, e não querySelector: o bloco tem limite de 1 no schema
       hoje, mas um `limit` de schema é uma promessa do editor, não do HTML —
       e quando ela falhasse, a segunda calculadora ficaria muda. */
    root.querySelectorAll('[data-td-cep]').forEach(function (caixa) {
      initUmCep(caixa, texts);
    });
  }

  function initUmCep(caixa, texts) {
    if (caixa.dataset.tdReady === 'true') return;

    var campo = caixa.querySelector('.td-field__control');
    var botao = caixa.querySelector('[data-td-cep-go]');
    var saida = caixa.querySelector('[data-td-cep-result]');
    if (!campo || !botao || !saida) return;
    caixa.dataset.tdReady = 'true';

    var CHAVE = 'td-cep';
    /* 🔴 Cada consulta ganha um número. Sem isto, ela digita um CEP, corrige
       para outro, e a resposta ATRASADA do primeiro chega por último e pinta o
       frete do endereço errado na tela — com cara de resultado certo. */
    var tentativa = 0;

    function digitos(valor) {
      return String(valor || '').replace(/\D/g, '').slice(0, 8);
    }

    function comTraco(valor) {
      var d = digitos(valor);
      return d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
    }

    /* O CEP guardado volta na próxima peça que ela abrir. localStorage pode
       simplesmente não existir (janela anônima, cookies bloqueados), e isso
       não pode derrubar a calculadora. */
    try {
      var salvo = window.localStorage.getItem(CHAVE);
      if (salvo) campo.value = comTraco(salvo);
    } catch (e) {
      /* sem memória: a calculadora continua funcionando, só não lembra. */
    }

    function dinheiro(valor) {
      var numero = parseFloat(valor);
      if (isNaN(numero)) return String(valor);
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: caixa.dataset.currency,
        }).format(numero);
      } catch (e) {
        return String(valor);
      }
    }

    function desenhar(dados) {
      var taxas = (dados && dados.shipping_rates) || [];
      if (!taxas.length) {
        saida.textContent = texts.cepNone || '';
        return;
      }
      var lista = document.createElement('ul');
      lista.className = 'td-cep__list';
      taxas.forEach(function (taxa) {
        var linha = document.createElement('li');
        linha.className = 'td-cep__option';
        var nome = document.createElement('span');
        nome.textContent = taxa.name || taxa.presentment_name || '';
        var preco = document.createElement('span');
        preco.className = 'td-cep__price';
        preco.textContent = dinheiro(taxa.price);
        linha.appendChild(nome);
        linha.appendChild(preco);
        lista.appendChild(linha);
      });
      saida.textContent = '';
      saida.appendChild(lista);
    }

    function consultar() {
      tentativa += 1;
      var minha = tentativa;

      var cep = digitos(campo.value);
      if (cep.length !== 8) {
        saida.textContent = texts.cepInvalid || '';
        return;
      }
      try {
        window.localStorage.setItem(CHAVE, cep);
      } catch (e) {
        /* idem: não lembrar não é motivo para não calcular. */
      }

      saida.textContent = texts.cepLoading || '';

      var url =
        caixa.dataset.ratesUrl +
        '?shipping_address%5Bzip%5D=' +
        encodeURIComponent(cep) +
        '&shipping_address%5Bcountry%5D=' +
        encodeURIComponent(caixa.dataset.country || '');

      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (resposta) {
          if (!resposta.ok) throw new Error(String(resposta.status));
          return resposta.json();
        })
        .then(function (dados) {
          if (minha === tentativa) desenhar(dados);
        })
        .catch(function () {
          if (minha !== tentativa) return;
          /* 🔴 Recusa da Shopify NÃO quer dizer "carrinho vazio": endereço
             inválido devolve o mesmo 422. Mandar alguém com o carrinho cheio
             "adicionar a peça ao carrinho" é dar a instrução errada e deixar a
             pessoa sem saída. Então eu PERGUNTO ao carrinho antes de afirmar. */
          fetch(caixa.dataset.cartUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function (r) {
              return r.ok ? r.json() : null;
            })
            .then(function (carrinho) {
              if (minha !== tentativa) return;
              var vazio = carrinho && carrinho.item_count === 0;
              saida.textContent = (vazio ? texts.cepEmptyCart : texts.cepError) || '';
            })
            .catch(function () {
              if (minha === tentativa) saida.textContent = texts.cepError || '';
            });
        });
    }

    botao.addEventListener('click', consultar);

    campo.addEventListener('input', function () {
      campo.value = comTraco(campo.value);
      /* Resultado antigo embaixo de um CEP novo é pior que resultado nenhum:
         ela leria o frete do endereço anterior como se fosse do que digitou. */
      saida.textContent = '';
    });

    /* Enter no campo calcula, e NÃO envia o formulário de compra: o campo
       vive dentro da página de produto e o Enter padrão levaria a cliente
       ao carrinho quando ela só queria ver o frete. */
    campo.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        consultar();
      }
    });
  }

  /* ------------------------------------------------------------------ *
   * A página de produto
   * ------------------------------------------------------------------ */
  function initProduct(root) {
    if (!root || root.dataset.tdReady === 'true') return;
    root.dataset.tdReady = 'true';

    var sectionId = root.dataset.section;
    var texts = textsOf(root);

    /* No editor de temas a seção é destruída e recriada a cada mudança de
       opção. Sem desligar assinatura e observadores, cada mudança deixa uma
       cópia viva apontando para um DOM que não existe mais — e as cópias
       antigas continuam procurando elementos pelo mesmo id da seção. Depois
       de vinte ajustes, o editor fica lento e ninguém sabe por quê. */
    var limpezas = [];
    root.tdCleanup = function () {
      limpezas.forEach(function (fn) {
        try {
          fn();
        } catch (e) {
          /* Limpeza que falha não pode derrubar o resto da limpeza. */
        }
      });
      limpezas = [];
      delete root.dataset.tdReady;
    };

    /* -------- E11: "escolha o tamanho" ---------------------------------
       O Dawn sempre deixa uma variante pré-escolhida. Isso faz a cliente
       adicionar ao carrinho um tamanho que ela nunca escolheu — é o item
       MB-3 do benchmark. Aqui a escolha volta a ser dela.

       Só mexemos quando a URL NÃO traz ?variant=: link de anúncio ou de
       e-mail que já aponta para um tamanho continua funcionando como
       antes, e ninguém perde a escolha que já tinha feito. */
    var precisaEscolher = false;

    function grupoDeTamanho() {
      if (root.dataset.tdRequireOption !== 'true') return null;
      var nomes = (root.dataset.tdOptionNames || '')
        .split(',')
        .map(function (n) {
          return n.trim().toLowerCase();
        })
        .filter(Boolean);
      if (!nomes.length) return null;

      var grupos = root.querySelectorAll('variant-selects fieldset');
      for (var i = 0; i < grupos.length; i++) {
        var marcado = grupos[i].querySelector('[data-option-name]');
        var nome = marcado ? (marcado.dataset.optionName || '').trim().toLowerCase() : '';
        if (nome && nomes.indexOf(nome) !== -1 && grupos[i].querySelector('input[type="radio"]')) {
          return grupos[i];
        }
      }
      return null;
    }

    function desmarcarTamanho() {
      var grupo = grupoDeTamanho();
      if (!grupo) return false;
      var radios = grupo.querySelectorAll('input[type="radio"]');
      if (radios.length < 2) return false;
      for (var i = 0; i < radios.length; i++) radios[i].checked = false;
      grupo.classList.add('td-option-group--pending');
      return true;
    }

    function botoes() {
      return [root.querySelector('.td-atc'), root.querySelector('.td-sticky-buy__button')].filter(Boolean);
    }

    function pintarEstadoEscolha() {
      botoes().forEach(function (botao) {
        var alvo = botao.querySelector('span');
        if (!alvo) return;
        if (precisaEscolher) {
          if (!botao.dataset.tdLabel) botao.dataset.tdLabel = alvo.textContent.trim();
          /* aria-disabled, e NÃO disabled: o plano pede um botão que
             pareça apagado mas continue clicável, para poder levar a
             cliente até o seletor em vez de simplesmente não reagir. */
          botao.setAttribute('aria-disabled', 'true');
          botao.classList.add('td-atc--choose');
          alvo.textContent = texts.chooseSize || alvo.textContent;
        } else if (botao.dataset.tdLabel) {
          botao.removeAttribute('aria-disabled');
          botao.classList.remove('td-atc--choose');
          alvo.textContent = botao.dataset.tdLabel;
          delete botao.dataset.tdLabel;
        }
      });
    }

    /* Rodada 2: além do destaque visual, a falta vira MENSAGEM anunciada (role=alert) e o foco
       vai para o primeiro tamanho — antes só havia rolagem e um piscar, que leitor de tela não
       percebe. Rolagem sem animação para quem pede movimento reduzido. */
    function rolagemSuave() {
      return !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }
    function avisarFalta(grupo, mensagem) {
      if (!grupo || !mensagem) return;
      var aviso = grupo.querySelector('.td-size-alert');
      if (!aviso) {
        aviso = document.createElement('p');
        aviso.className = 'td-size-alert';
        aviso.setAttribute('role', 'alert');
        grupo.appendChild(aviso);
      }
      aviso.textContent = '';
      window.setTimeout(function () { aviso.textContent = mensagem; }, 60);
    }
    function destacarTamanho() {
      var grupo = grupoDeTamanho();
      if (!grupo) return;
      avisarFalta(grupo, texts.chooseSize);
      var primeiro = grupo.querySelector('input:not([disabled]), select');
      if (primeiro) primeiro.focus({ preventScroll: true });
      grupo.scrollIntoView({ behavior: rolagemSuave() ? 'smooth' : 'auto', block: 'center' });
      grupo.classList.add('td-option-group--flash');
      window.setTimeout(function () {
        grupo.classList.remove('td-option-group--flash');
      }, 1000);
    }

    /* Rodada 3: `td_cor=1` vem da bolinha de cor (card e compra rápida): a variante da URL
       fixa a COR, mas o TAMANHO continua sendo escolha dela. */
    var tdUrl = new URL(window.location.href).searchParams;
    if (!tdUrl.has('variant') || tdUrl.get('td_cor') === '1') {
      precisaEscolher = desmarcarTamanho();
      pintarEstadoEscolha();
    }

    /* E7 — o campo de segundo tamanho é obrigatório de verdade.
       🔴 O `required` do HTML não vale aqui: o formulário de produto do Dawn
       é criado com `novalidate`, então o navegador simplesmente não valida
       nada. Descobri isso lendo o buy-buttons, e sem esta função o
       "Obrigatório" do editor seria uma promessa que o tema não cumpre. */
    function segundoTamanhoFaltando() {
      var campo = root.querySelector('.td-second-size .td-field__control[required]');
      if (!campo) return null;
      return String(campo.value || '').trim() === '' ? campo : null;
    }

    /* Captura, e não bolha: o <product-form> do Dawn escuta o submit no
       modo bolha. Chegando antes dele, seguramos o envio sem precisar
       conhecer nem tocar no código dele. */
    root.addEventListener(
      'submit',
      function (event) {
        /* 🔴 Só o formulário de COMPRA é interceptado. Sem esta linha, o
           `<form method="dialog">` que fecha a tabela de medidas também era
           cancelado enquanto o tamanho não estivesse escolhido — o X do modal
           simplesmente parava de fechar, e ninguém ligaria uma coisa à outra. */
        /* 🔴 Rodada 2: `event.target.id` NÃO serve aqui — o formulário do Dawn tem um
           <input name="id"> (a variante), e `form.id` devolve ESSE input, não o atributo id.
           A comparação dava sempre diferente e a validação de tamanho nunca rodava. */
        if (event.target.getAttribute('id') !== 'product-form-' + sectionId) return;

        if (precisaEscolher) {
          event.preventDefault();
          event.stopPropagation();
          destacarTamanho();
          return;
        }

        var faltando = segundoTamanhoFaltando();
        if (faltando) {
          event.preventDefault();
          event.stopPropagation();
          var caixa = faltando.closest('.td-field') || faltando;
          avisarFalta(caixa, texts.chooseSize);
          caixa.scrollIntoView({ behavior: rolagemSuave() ? 'smooth' : 'auto', block: 'center' });
          caixa.classList.add('td-option-group--flash');
          window.setTimeout(function () {
            caixa.classList.remove('td-option-group--flash');
          }, 1000);
          faltando.focus({ preventScroll: true });
        }
      },
      true
    );

    root.addEventListener('change', function (event) {
      if (!precisaEscolher) return;
      var input = event.target;
      if (!input || input.type !== 'radio') return;
      var grupo = input.closest('fieldset');
      if (!grupo || !grupo.classList.contains('td-option-group--pending')) return;
      precisaEscolher = false;
      grupo.classList.remove('td-option-group--pending');
      pintarEstadoEscolha();
    });

    /* -------- Sincronizar os blocos quando a variante muda -------------
       O Dawn já busca o HTML novo da seção para atualizar preço e
       estoque. Aproveitamos EXATAMENTE esse HTML: nenhuma requisição a
       mais, nenhum cálculo repetido no navegador. */
    function sincronizar(html) {
      SYNC_IDS.forEach(function (id) {
        var origem = html.getElementById(id + '-' + sectionId);
        var destino = document.getElementById(id + '-' + sectionId);
        if (origem && destino) destino.innerHTML = origem.innerHTML;
      });

      var precoOrigem = html.getElementById('TdBuyPrice-' + sectionId);
      var precoDestino = document.getElementById('TdBuyPrice-' + sectionId);
      if (precoDestino) {
        if (precoOrigem) {
          precoDestino.innerHTML = precoOrigem.innerHTML;
          precoDestino.hidden = false;
        } else {
          /* Variante esgotada: o preço sai do botão. Preço em botão que
             não compra é ruído. */
          precoDestino.hidden = true;
        }
      }

      if (precisaEscolher) {
        /* Ela trocou a COR, não o tamanho: o HTML novo volta com um
           tamanho pré-escolhido pelo Dawn e o estado precisa voltar. */
        desmarcarTamanho();
        pintarEstadoEscolha();
      }

      /* K8 (Fase 6) — o link do WhatsApp acompanha o tamanho escolhido.
         O título da variante sai do MESMO HTML que o Dawn já buscou: nenhuma
         requisição a mais e nenhuma segunda fonte de verdade sobre qual
         variante está ativa. */
      sincronizarWhatsapp(root, html);

      /* F2/F5 — o seletor foi substituído inteiro; a marca do tamanho
         sugerido veio do servidor só na parte do F5 (histórico de compra). A
         parte do F2 mora no navegador dela e precisa ser repintada aqui. */
      marcarSugerido(root);

      espelharBarra();
    }

    if (typeof subscribe === 'function') {
      /* `subscribe` devolve a função que cancela a assinatura. Guardar esse
         retorno é o que permite a limpeza acima existir. */
      limpezas.push(
        subscribe(EVENT_VARIANT_CHANGE, function (payload) {
          var dados = payload && payload.data;
          if (!dados || String(dados.sectionId) !== String(sectionId) || !dados.html) return;
          sincronizar(dados.html);
        })
      );
    }

    /* -------- G9: a barra de compra fixa ------------------------------ */
    var barra = root.querySelector('.td-sticky-buy');
    var principal = root.querySelector('.td-atc');

    function espelharBarra() {
      if (!barra || !principal) return;
      var espelho = barra.querySelector('.td-sticky-buy__button');
      var rotulo = barra.querySelector('.td-sticky-buy__label');
      var preco = barra.querySelector('.td-sticky-buy__price');
      var rotuloPrincipal = principal.querySelector('span');
      var precoPrincipal = principal.querySelector('.td-atc__price');
      if (!espelho || !rotulo) return;

      /* O `loading` entra na conta: enquanto o carrinho responde, o botão
         principal fica bloqueado. Sem espelhar isso, um toque na barra
         mandaria uma SEGUNDA adição — e o Dawn poderia estar no meio da
         troca de variante, com o id antigo ainda no formulário. */
      espelho.disabled = principal.disabled || principal.classList.contains('loading');
      espelho.classList.toggle('td-atc--choose', principal.classList.contains('td-atc--choose'));
      if (principal.hasAttribute('aria-disabled')) espelho.setAttribute('aria-disabled', 'true');
      else espelho.removeAttribute('aria-disabled');

      if (rotuloPrincipal) rotulo.textContent = rotuloPrincipal.textContent.trim();
      if (preco) {
        var visivel = !!precoPrincipal && !precoPrincipal.hidden;
        preco.hidden = !visivel;
        if (visivel) preco.textContent = precoPrincipal.textContent.trim();
      }
    }

    if (barra && principal) {
      espelharBarra();

      /* Espelhar "quando eu lembrar de chamar" é o jeito de esquecer um
         caso. O observador copia SEMPRE: bloqueio, rótulo, preço e o
         estado de carregando, inclusive nos instantes em que o Dawn mexe
         no botão sem avisar ninguém. */
      if ('MutationObserver' in window) {
        var espiao = new MutationObserver(espelharBarra);
        espiao.observe(principal, {
          attributes: true,
          attributeFilter: ['class', 'disabled', 'aria-disabled'],
          childList: true,
          subtree: true,
          characterData: true,
        });
        limpezas.push(function () {
          espiao.disconnect();
        });
      }

      if ('IntersectionObserver' in window) {
        var vigia = new IntersectionObserver(
          function (entradas) {
            /* Enquanto o botão de verdade está na tela, a barra não
               aparece: dois botões iguais ao mesmo tempo é ruído. */
            visivelPrincipal = entradas[0].isIntersecting;
            decidirBarra();
          },
          { threshold: 0 }
        );
        /* Rodada 2: na primeira tela a barra também fica escondida até a cliente rolar um
           pouco. Ela nascia por cima do NOME e do PREÇO da peça no celular (a primeira dobra
           mostrava foto + "Escolha o tamanho" e nada de nome/preço). */
        var visivelPrincipal = false;
        /* Rodada 3 (auditoria 2, item 18): com a galeria limitada a ~50vh, nome e preço já
           cabem na primeira tela do celular, mas o botão de compra ficava a ~1200 px. No
           topo da página a barra passa a aparecer SE couber abaixo do preço sem cobri-lo
           (medido, não suposto); se não couber, continua escondida até a rolagem. */
        var alturaBarra = 0;
        var decidirBarra = function () {
          if (visivelPrincipal) { barra.hidden = true; return; }
          if (window.scrollY >= 160 || principal.getBoundingClientRect().top <= 0) { barra.hidden = false; return; }
          /* A referência é o VALOR que a cliente VÊ, não o bloco inteiro de preço (o selo
             "Promoção" e o parcelamento podem ficar sob a barra).
             Rodada 4 (auditoria 3, R3-03): o span do preço promocional existe mesmo quando a
             peça NÃO está em promoção (fica dentro de .price__sale com display:none) e o
             retângulo dele é 0 — a conta dava "cabe" sempre. Agora vale o primeiro candidato
             com retângulo de verdade; sem nenhum, a barra fica escondida (lado seguro). */
          /* Por PRIORIDADE (e não pela ordem no documento, onde o título vem antes do preço):
             preço promocional visível → preço normal visível → bloco de preço → título. */
          var ref = null;
          var prioridade = ['.product__info-container .price .price-item--last',
            '.product__info-container .price .price-item--regular', '.product__info-container .price', '.product__title'];
          for (var pi = 0; pi < prioridade.length && !ref; pi++) {
            var lista = root.querySelectorAll(prioridade[pi]);
            for (var ci = 0; ci < lista.length; ci++) {
              if (lista[ci].closest('.td-sticky-buy')) continue;
              var rc = lista[ci].getBoundingClientRect();
              if (rc.width > 0 && rc.height > 0) { ref = lista[ci]; break; }
            }
          }
          var altura = barra.offsetHeight || alturaBarra || 88;
          var cabe = !!ref && ref.getBoundingClientRect().bottom <= window.innerHeight - altura - 8;
          barra.hidden = !cabe;
          if (cabe && barra.offsetHeight) alturaBarra = barra.offsetHeight;
        };
        var aoRolar = function () { window.requestAnimationFrame(decidirBarra); };
        window.addEventListener('scroll', aoRolar, { passive: true });
        /* Rodada 4 (R3-03): recalcula também quando a tela muda de tamanho, quando as fontes
           terminam de carregar (o título pode quebrar em mais linhas) e quando a variante muda
           (o preço é redesenhado pelo Dawn). */
        window.addEventListener('resize', aoRolar, { passive: true });
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(aoRolar);
        var desligarVariante = null;
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          desligarVariante = subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(aoRolar, 60); });
        }
        /* A foto da galeria e os blocos acima do preço mudam de altura depois da primeira
           decisão (imagem chegando, fonte, selos). Medido em 390×740: a barra foi decidida com
           a galeria ainda curta e ficou por cima do preço. Qualquer mudança de tamanho da
           coluna de informações refaz a conta. */
        var observaTamanho = null;
        if ('ResizeObserver' in window) {
          observaTamanho = new ResizeObserver(aoRolar);
          var colunaInfo = root.querySelector('.product__info-container');
          if (colunaInfo) observaTamanho.observe(colunaInfo);
          var galeria = root.querySelector('media-gallery, .product__media-wrapper');
          if (galeria) observaTamanho.observe(galeria);
        }
        window.addEventListener('load', aoRolar);
        vigia.observe(principal);
        limpezas.push(function () {
          vigia.disconnect();
          if (observaTamanho) observaTamanho.disconnect();
          window.removeEventListener('load', aoRolar);
          window.removeEventListener('scroll', aoRolar);
          window.removeEventListener('resize', aoRolar);
          if (typeof desligarVariante === 'function') desligarVariante();
        });
      }
    }

    /* -------- I1: bolinhas da galeria no celular ---------------------- */
    initDots(root, texts);

    /* -------- I4: descrição em duas linhas no celular ----------------- */
    initDescription(root, texts);

    /* -------- G8: a calculadora de CEP -------------------------------- */
    initCep(root, texts);

    /* -------- F2 (Fase 6): a calculadora de tamanho por medidas ------- */
    initFit(root, texts);

    /* -------- F2/F5 (Fase 6): o tamanho sugerido no seletor -----------
       Roda no carregamento e de novo a cada troca de variante, porque o Dawn
       substitui o seletor inteiro e leva a marca junto. */
    marcarSugerido(root);

    /* A dobra da descrição só existe abaixo de 750px. Quem abre no
       computador e estreita a janela — ou vira o tablet — passa a ter texto
       cortado; sem esta linha, ficaria cortado e sem botão para abrir. */
    if (window.matchMedia) {
      var telaEstreita = window.matchMedia('(max-width: 749px)');
      var aoMudarTela = function () {
        initDescription(root, texts);
      };
      if (telaEstreita.addEventListener) {
        telaEstreita.addEventListener('change', aoMudarTela);
        limpezas.push(function () {
          telaEstreita.removeEventListener('change', aoMudarTela);
        });
      }
    }
  }

  /* ------------------------------------------------------------------ *
   * F2 (Fase 6) — a calculadora de tamanho por medidas.
   *
   * A tabela de faixas vem do metafield, ja em JSON, escrita pelo Liquid.
   * Nao existe uma unica medida escrita aqui dentro: a calculadora nao sabe
   * o que e "M", so sabe comparar numeros com as faixas que recebeu.
   *
   * 🔴 O que fica guardado no navegador e SO A LETRA DO TAMANHO. As medidas
   * em centimetro nao saem do formulario — medida de corpo e dado sensivel, e
   * o plano so pede que o RESULTADO volte na proxima peca.
   * ------------------------------------------------------------------ */
  var CHAVE_TAMANHO = 'td-fit-size';

  function lerTamanhoSalvo() {
    try {
      return localStorage.getItem(CHAVE_TAMANHO) || '';
    } catch (e) {
      /* Janela anonima com armazenamento bloqueado. Sem sugestao e o estado
         seguro: o seletor continua exatamente como o servidor mandou. */
      return '';
    }
  }

  function salvarTamanho(tamanho) {
    try {
      localStorage.setItem(CHAVE_TAMANHO, tamanho);
    } catch (e) {
      /* Nao guardou; a resposta desta pagina continua valendo. */
    }
  }

  /* Aceita "88", "88,5" e "88.5". O teclado brasileiro manda virgula, e um
     `type="number"` que devolve vazio na virgula faria a cliente concluir
     que a calculadora nao funciona.

     🔴 A validacao e ESTRITA, e a revisao mostrou por que: a versao anterior
     limpava os caracteres ANTES de validar, entao "-90" virava 90, "8a8"
     virava 88 e "88.5.9" virava 88.5. A calculadora respondia com confianca a
     partir de um numero que a cliente nunca digitou — e o resultado ainda
     ficava guardado para as proximas pecas. Agora, texto que nao for um
     decimal positivo simplesmente nao e medida. */
  function medida(campo) {
    if (!campo) return 0;
    var bruto = String(campo.value || '').trim().replace(',', '.');
    if (!/^\d{1,3}(\.\d{1,2})?$/.test(bruto)) return 0;
    var n = parseFloat(bruto);
    if (!isFinite(n)) return 0;
    if (n <= 0) return 0;
    return n;
  }

  function initFit(root, texts) {
    var caixa = root.querySelector('[data-td-fit]');
    if (!caixa) return;
    if (caixa.dataset.tdReady === 'true') return;
    caixa.dataset.tdReady = 'true';

    var fonte = caixa.querySelector('[data-td-fit-table]');
    var tabela = null;
    try {
      tabela = JSON.parse(fonte.textContent);
    } catch (e) {
      return;
    }
    if (!tabela || !tabela.linhas || !tabela.linhas.length) return;

    var campo1 = caixa.querySelector('[data-td-fit-m1]');
    var campo2 = caixa.querySelector('[data-td-fit-m2]');
    var botao = caixa.querySelector('[data-td-fit-go]');
    var saida = caixa.querySelector('[data-td-fit-result]');
    if (!botao || !saida) return;

    function responder() {
      var m1 = medida(campo1);
      var m2 = medida(campo2);

      saida.textContent = '';

      if (!m1) {
        saida.textContent = texts.fitAskFirst || '';
        if (campo1) campo1.focus();
        return;
      }
      if (tabela.duas && !m2) {
        saida.textContent = texts.fitAskSecond || '';
        if (campo2) campo2.focus();
        return;
      }

      /* Duas passagens: primeiro o encaixe exato nas duas medidas; se
         nenhuma linha servir, o encaixe pela PRIMEIRA medida sozinha.
         🔴 E nunca um "mais proximo": entre duas faixas, a resposta certa e a
         frase que ja esta na tela desde a Fase 2 — "na duvida entre dois
         tamanhos, fique com o maior" —, e nao um palpite com cara de calculo. */
      var achou = '';
      tabela.linhas.forEach(function (linha) {
        if (achou) return;
        if (m1 < linha.a1) return;
        if (m1 > linha.b1) return;
        if (tabela.duas && linha.b2 > 0) {
          if (m2 < linha.a2) return;
          if (m2 > linha.b2) return;
        }
        achou = linha.t;
      });

      /* 🔴 A segunda passagem — encaixe so pela PRIMEIRA medida — vale
         apenas quando a tabela nao pede duas. A revisao pegou o furo: com uma
         tabela de busto E quadril, um quadril fora de todas as faixas ainda
         devolvia um tamanho, com cara de resposta calculada, e esse tamanho
         ainda era guardado para as proximas pecas. Quando a peca pede as duas
         medidas, ou as duas batem ou a resposta e "fora da tabela". */
      if (!achou && !tabela.duas) {
        tabela.linhas.forEach(function (linha) {
          if (achou) return;
          if (m1 < linha.a1) return;
          if (m1 > linha.b1) return;
          achou = linha.t;
        });
      }

      if (!achou) {
        /* Fora da tabela inteira. Dizer isso e melhor do que empurrar o maior
           tamanho: a peca pode simplesmente nao servir nela, e descobrir isso
           agora custa menos que descobrir na devolucao. */
        saida.textContent = texts.fitNone || '';
        return;
      }

      salvarTamanho(achou);

      /* A frase vem do idioma, com o tamanho entrando num lugar reservado. */
      var frase = document.createElement('span');
      frase.className = 'td-fit__answer';
      frase.textContent = (texts.fitResult || '%SIZE%').replace('%SIZE%', achou);
      saida.appendChild(frase);

      var usar = document.createElement('button');
      usar.type = 'button';
      usar.className = 'td-btn td-btn--accent td-btn--sm td-fit__use';
      usar.textContent = (texts.fitUse || '%SIZE%').replace('%SIZE%', achou);
      usar.addEventListener('click', function () {
        /* 🔴 Fechar SO se aplicou. Antes o dialogo fechava de qualquer jeito:
           num seletor em modo "lista suspensa" a busca nao achava nada, a
           variante continuava a anterior e a cliente saia convencida de que
           tinha escolhido o tamanho calculado. (Revisao da Fase 6.) */
        if (!aplicarTamanho(root, achou)) {
          saida.appendChild(document.createTextNode(' '));
          var falhou = document.createElement('span');
          falhou.className = 'td-fit__warn';
          falhou.textContent = texts.fitManual || '';
          saida.appendChild(falhou);
          usar.disabled = true;
          return;
        }
        var dialogo = caixa.closest('dialog');
        if (dialogo && typeof dialogo.close === 'function') dialogo.close();
      });
      saida.appendChild(usar);
    }

    botao.addEventListener('click', responder);

    /* Enter dentro de um dos campos responde, em vez de nao fazer nada.
       ⚠️ E preciso barrar o evento: este bloco vive dentro de um <dialog> na
       pagina de produto, e um Enter que sobe daqui pode acabar submetendo o
       formulario de compra. Foi exatamente o tipo de cruzamento que a revisao
       da Fase 2 achou entre o bloqueio de envio e o X do modal. */
    caixa.addEventListener('keydown', function (evento) {
      if (evento.key !== 'Enter') return;
      if (!evento.target.closest('.td-fit__input')) return;
      evento.preventDefault();
      responder();
    });
  }

  /* Marca (e, se o editor mandar, seleciona) o tamanho no seletor. E o mesmo
     caminho usado pelo botao "usar este tamanho" da calculadora. */
  function aplicarTamanho(root, tamanho) {
    var alvo = acharRadioDeTamanho(root, tamanho);
    if (!alvo) return false;

    if (alvo.tagName === 'OPTION') {
      var lista = alvo.closest('select');
      if (!lista) return false;
      if (lista.value === alvo.value) return true;
      lista.value = alvo.value;
      lista.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    if (alvo.checked) return true;
    alvo.checked = true;
    /* `bubbles: true` porque quem escuta e o <variant-selects>, la em cima. */
    alvo.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  /* Quais nomes de opcao contam como tamanho — a MESMA lista do E11, que ja
     chega no `data-td-option-names`. Sem ela, a busca comparava o valor em
     TODOS os controles do seletor, e uma cor chamada "M" (ou um comprimento,
     ou um bojo) podia ser marcada no lugar do tamanho. (Revisao da Fase 6.) */
  function nomesDeTamanho(root) {
    return (root.dataset.tdOptionNames || '')
      .split(',')
      .map(function (n) {
        return n.trim().toLowerCase();
      })
      .filter(Boolean);
  }

  function ehDeTamanho(controle, nomes) {
    if (!nomes.length) return true;
    var nome = (controle.dataset.optionName || '').trim().toLowerCase();
    if (!nome) return true;
    return nomes.indexOf(nome) !== -1;
  }

  /* Devolve o controle do tamanho pedido — radio OU <option> de lista
     suspensa. O seletor do Dawn e uma setting do editor ("botao" ou "lista"),
     e a versao anterior so entendia botao. */
  function acharRadioDeTamanho(root, tamanho) {
    if (!tamanho) return null;
    var nomes = nomesDeTamanho(root);
    var procurado = String(tamanho).trim().toLowerCase();
    var alvo = null;

    root.querySelectorAll('variant-selects input[type="radio"]').forEach(function (radio) {
      if (alvo) return;
      if (!ehDeTamanho(radio, nomes)) return;
      if (String(radio.value || '').trim().toLowerCase() === procurado) alvo = radio;
    });
    if (alvo) return alvo;

    root.querySelectorAll('variant-selects select option').forEach(function (opcao) {
      if (alvo) return;
      if (!ehDeTamanho(opcao, nomes)) return;
      if (String(opcao.value || '').trim().toLowerCase() === procurado) alvo = opcao;
    });
    return alvo;
  }

  function marcarSugerido(root) {
    var tamanho = lerTamanhoSalvo();
    if (!tamanho) return;

    var radio = acharRadioDeTamanho(root, tamanho);
    if (!radio) return;

    /* No modo "lista suspensa" nao existe pilula para marcar. A sugestao
       continua valendo (o F5 escreve a linha de texto pelo servidor); o que
       nao existe e o fio dourado. */
    var rotulo = radio.id ? root.querySelector('label[for="' + radio.id + '"]') : null;
    if (!rotulo) return;

    /* 🔴 O F5 vence o F2. Se o servidor ja marcou um tamanho, ele veio do
       HISTORICO DE COMPRA dela — dado real, e mais forte do que uma conta de
       fita metrica feita numa outra peca. Nao existem duas marcas na tela. */
    if (root.querySelector('.td-pill--suggested')) return;
    rotulo.classList.add('td-pill--suggested');

    /* ⚠️ Pre-selecionar e OPT-IN, e nasce desligado. O item E11 da Fase 2
       existe justamente para a cliente escolher o tamanho em vez de herdar
       um; o plano da Fase 6 pede a pre-selecao, e a saida honesta e deixar a
       decisao no editor com o motivo escrito ao lado. */
    if (root.dataset.tdFitAutoselect !== 'true') return;
    if (window.location.search.indexOf('variant=') !== -1) return;
    /* 🔴 E so nesta peca ter a PROPRIA tabela de faixas. A revisao apontou o
       risco com razao: o tamanho salvo veio da tabela de OUTRA peca, e uma
       letra sozinha nao carrega a grade que a produziu. Com a tabela desta
       peca presente, o "M" pelo menos e um M que esta peca vende e mede.
       Sem tabela aqui, fica so o fio dourado — sugestao, nunca escolha. */
    if (!root.querySelector('[data-td-fit-table]')) return;
    aplicarTamanho(root, tamanho);
  }

  /* ------------------------------------------------------------------ *
   * K8 (Fase 6) — o link do WhatsApp acompanha o tamanho escolhido.
   * ------------------------------------------------------------------ */
  function sincronizarWhatsapp(root, html) {
    var link = root.querySelector('[data-td-wa]');
    if (!link) return;

    var titulo = '';
    if (link.dataset.tdWaMulti === 'true') {
      var no = html.querySelector('[data-selected-variant]');
      if (no) {
        try {
          var variante = JSON.parse(no.textContent);
          titulo = (variante && variante.title) || '';
        } catch (e) {
          /* JSON quebrado: o link continua com o texto que veio do servidor,
             que ainda esta correto para a variante anterior. Melhor um texto
             levemente velho do que um link sem mensagem nenhuma. */
          return;
        }
      }
    }

    var molde = titulo
      ? (link.getAttribute('data-td-wa-sized') || '').replace('%SIZE%', titulo)
      : link.getAttribute('data-td-wa-plain') || '';
    if (!molde) return;

    link.href =
      'https://wa.me/' + link.getAttribute('data-td-wa-number') + '?text=' + encodeURIComponent(molde);
  }

  /* ------------------------------------------------------------------ *
   * I1 — as bolinhas.
   * O Dawn mostra "1 / 5" e duas setas. No celular, seta em cima da foto
   * é alvo pequeno e a contagem não diz onde ela está. As bolinhas são
   * construídas aqui e sincronizadas por IntersectionObserver na própria
   * lista que já rola com scroll-snap — nenhum carrossel novo.
   * ------------------------------------------------------------------ */
  function initDots(root, texts) {
    /* As bolinhas só existem na galeria sangrada do celular. Com a opção
       desligada, o Dawn continua com as setas e o contador dele, e criar
       bolinhas escondidas seria nó no DOM sem função nenhuma. */
    if (!root.classList.contains('td-pdp--bleed')) return;

    var lista = root.querySelector('.product__media-list');
    if (!lista) return;
    var slides = Array.prototype.slice.call(lista.querySelectorAll('.product__media-item'));
    if (slides.length < 2) return;
    if (lista.parentNode.querySelector('.td-dots')) return;

    var molde = texts.photo || '%d';
    var dots = document.createElement('div');
    dots.className = 'td-dots';

    slides.forEach(function (slide, indice) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'td-dots__dot';
      dot.setAttribute('aria-label', molde.replace('%d', String(indice + 1)));
      dot.addEventListener('click', function () {
        slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
      dots.appendChild(dot);
    });

    lista.parentNode.insertBefore(dots, lista.nextSibling);

    if (!('IntersectionObserver' in window)) return;
    var observador = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (entrada) {
          var indice = slides.indexOf(entrada.target);
          if (indice < 0) return;
          var dot = dots.children[indice];
          if (!dot) return;
          dot.classList.toggle('td-dots__dot--active', entrada.isIntersecting);
          if (entrada.isIntersecting) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      },
      { root: lista, threshold: 0.6 }
    );
    slides.forEach(function (slide) {
      observador.observe(slide);
    });
  }

  /* ------------------------------------------------------------------ *
   * I4 — a descrição resumida.
   * O botão só nasce se o texto realmente não coube: "Ler mais" em cima
   * de uma descrição de uma linha é ruído. Quem mede é o navegador
   * (scrollHeight contra clientHeight), não um chute de contagem de
   * caracteres, que erraria em toda tela diferente.
   * ------------------------------------------------------------------ */
  function initDescription(root, texts) {
    var desc = root.querySelector('.td-desc');
    if (!desc || desc.dataset.tdReady === 'true') return;

    /* A dobra só existe no celular; no computador o CSS não corta nada. */
    if (desc.scrollHeight <= desc.clientHeight + 1) return;
    desc.dataset.tdReady = 'true';

    var botao = document.createElement('button');
    botao.type = 'button';
    botao.className = 'td-btn td-btn--link td-btn--sm td-desc__more';
    botao.setAttribute('aria-expanded', 'false');
    botao.textContent = texts.readMore || '';
    if (!botao.textContent) return;

    botao.addEventListener('click', function () {
      var aberto = desc.classList.toggle('td-desc--open');
      botao.setAttribute('aria-expanded', aberto ? 'true' : 'false');
      botao.textContent = aberto ? texts.readLess || botao.textContent : texts.readMore;
    });

    desc.parentNode.insertBefore(botao, desc.nextSibling);
  }

  function iniciar(escopo) {
    initModals();
    initCopy();
    (escopo || document).querySelectorAll('product-info.td-pdp').forEach(function (root) {
      initProduct(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciar(document);
    });
  } else {
    iniciar(document);
  }

  /* No editor de temas a seção é recriada a cada mudança de setting.
     Sem isto, o Marcus mexeria numa opção e tudo aqui pararia de
     funcionar até ele recarregar a página — e ele concluiria, com razão,
     que a entrega está quebrada. */
  document.addEventListener('shopify:section:load', function (event) {
    iniciar(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var alvo = event.target;
    if (!alvo || !alvo.querySelectorAll) return;
    alvo.querySelectorAll('product-info.td-pdp').forEach(function (root) {
      if (typeof root.tdCleanup === 'function') root.tdCleanup();
    });
  });
})();
